<template>
  <div class="refundability">
    <vb-icon class="refundability__icon" :name="refundable.icon" :color="sass(refundable.variant)" :size="16" />
    <span :class="'refundability__text refundability__text--' + refundable.variant">{{ refundable.text }}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'refundability',

  components: {
  },

  props: {
    cancellation: Object,
  },

  data() {
    return {
    }
  },

  computed: {

    refundable() {
      const { refundable, refundableBefore } = this.cancellation.refundability,
            formatted_date = refundable
              ? moment(refundableBefore, 'DD-MM-YYYY HH:mm:ss Z').format('DD-MM-YYYY')
              : ''

      return {
        text: refundable
          ? `Cancellazione gratuita fino al ${formatted_date}`
          : 'Non rimborsabile',
        icon: refundable ? 'check-circle' : 'lock_v2',
        variant: refundable ? 'success' : 'dark',
      }
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .refundability {
    line-height: normal;
    display: flex;
    align-items: flex-start;
    font-size: $font-size-md;

    &__text {

      &--success {
        color: $success;
      }
    }

    &__icon {
      display: none;

      @include media-breakpoint-up(sm){
        display: block;
        margin-right: 5px;
      }

      &--info {
        margin: 2px 0 0 5px;
      }
    }
  }

</style>